import { getProfileRoute } from '../../utils/profileRoute';
import { User } from '../../services/authService.ts';

type UserSummary = Pick<User, 'perfil' | 'role'>;

export interface LandingMenuItem {
    to: string;
    label: string;
    icon: 'profile' | 'platform' | 'admin';
}

export const getUserLevelLabel = (user: UserSummary | null | undefined) =>
    user?.role?.trim() || (user?.perfil === 'personal' ? 'Personal Co Marca' : user?.perfil === 'cliente' ? 'Miembro' : 'Usuario');

export const buildLandingUserMenu = (user: UserSummary | null | undefined): LandingMenuItem[] => [
    { to: getProfileRoute(user), label: 'Mi Perfil', icon: 'profile' },
    user?.perfil === 'personal'
        ? { to: '/dashboard', label: 'Dashboard administrativo', icon: 'admin' }
        : { to: '/midashboard', label: 'Mi plataforma', icon: 'platform' },
];
